import {FC} from 'react';

import {GlobalKeyboardActionEventHandler, useKeyboardGlobalListener} from './keyboardContext';

/*
 * Props.
 */

interface KeyboardGlobalListenerProps {
  /** Handler to intercept a keyboard event and maybe take some action. */
  onInterceptAction: GlobalKeyboardActionEventHandler;
}

/*
 * Component.
 */

export const KeyboardGlobalListener: FC<KeyboardGlobalListenerProps> = ({onInterceptAction}) => {
  useKeyboardGlobalListener(onInterceptAction);

  return null;
};
